import { isVNR } from "./FobiCore";
import { toast } from 'react-toastify';
import { setScreen, setScreenVeranstaltung, appScreens } from './store/appNavigation/actions';
import { addVeranstaltungPanelSetVNR, setShowAddVeranslatungsPanel } from './store/veranstaltungen/actions';

export const getIntendedVNR = () => {
	const params = new URLSearchParams(window.location.search);
	const vnr = params.get('vnr');
	return vnr;
}
export const applyVNR = (store, vnr) => {
	if(!isVNR(vnr)){
		toast.warning("VNR ist ungültig");
		return;
	}
	const state = store.getState();
	const vnrLoaded = state && state.veranstaltungen[vnr];
	if(vnrLoaded){
		store.dispatch(setScreenVeranstaltung(vnr));
	}else{
		// **Reihenfolge: VNR, Panel, erst dann die Seite.** Ziel ist die Veranstalterseite, denn
		// dort lebt das Formular - auf der Startseite wurde bisher ein Panel geoeffnet, das dort
		// gar nicht gerendert wird: der Anwender landete auf der Begruessungsseite, ohne ein Wort
		// zu seinem Link, und musste den Weg selbst finden.
		//
		// Dass die Navigation zuletzt kommt, ist keine Kosmetik: der Fokus im Kennwortfeld haengt
		// an `autoFocus={!!vnr}` und damit daran, dass die VNR **vor** dem Mount des Formulars im
		// Store steht. Heute laeuft applyVNR ohnehin vor dem ersten Render - aber so traegt der
		// Code die Bedingung selbst und haelt auch, wenn das einmal nicht mehr stimmt.
		store.dispatch(addVeranstaltungPanelSetVNR(vnr));
		store.dispatch(setShowAddVeranslatungsPanel(true));
		store.dispatch(setScreen(appScreens.veranstalterPage));
	}
}


	/*
appNavigation: 
currentScreen:"veranstalterPage"
displayDialogQrcodeLinkToApp:false
saveStateToLocalStorage:true
selectedVNR:"2760602023000160003"
	*/


